import React, { useEffect, useState, useRef } from "react";
import fetch from "node-fetch";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useParams } from "react-router-dom";
import "./index.css";
import { API_URL, CONF } from "../config";
import ReCAPTCHA from "react-google-recaptcha";

const initialFormState = {
  posterId: "",
  title: "",
  authors: "",
  topic: "",
  session: "",
  file: "",
  fileName: "",
  recordingFile: "",
  recordingFileName: "",

  authorFullName: "",
  authorEmail: "",
  authorFacebook: "",
  authorSkype: "",

  fullName: "",
  email: "",
  phone: "",

  gdprConsent: false,
  postersConsent: false,
  posterIdInvalid: false,
  posterIdValidationMessage: "",
  fileValid: false,
  validationMessage: "",
  recordingFileInvalid: false,
  recordingFileValidationMessage: "",

  failure: false,
  isSending: false,
  sent: false,
};

const NewApplication = () => {
  const { posterId } = useParams();
  const recaptchaRef = useRef(null);
  const [formState, setFormState] = useState(initialFormState);

  useEffect(() => {
    const getApplicationDetails = async () => {
      try {
        const result = await fetch(`${API_URL}/new-application/${posterId}?conf=${CONF}`);
        const details = await result.json();

        setFormState({
          ...details,
        });
      } catch (e) {
        console.log(e);
      }
    };

    posterId && getApplicationDetails();
  }, [posterId]);

  const handleSubmit = async (event) => {
    event.persist();
    event.preventDefault();
    event.stopPropagation();

    const data = new FormData();

    const {
      title,
      authors,
      file,
      fileName,
      recordingFile,
      recordingFileName,
      consent,
      posterId,
      topic,
      authorFullName,
      authorEmail,
      authorFacebook,
      authorSkype,
      fullName,
      email,
      phone,
      gdprConsent,
      postersConsent,
    } = formState;

    let recaptchaCode = recaptchaRef.current.getValue();

    data.append("title", title);
    data.append("authors", authors);
    data.append("fileName", fileName.replaceAll(" ", ""));
    data.append("recordingFileName", recordingFileName.replaceAll(" ", ""));
    data.append("file", file);
    data.append("recordingFile", recordingFile);
    data.append("consent", consent);
    data.append("posterId", posterId);
    data.append("topic", topic);
    data.append("authorFullName", authorFullName);
    data.append("authorEmail", authorEmail);
    data.append("authorFacebook", authorFacebook);
    data.append("authorSkype", authorSkype);
    data.append("fullName", fullName);
    data.append("email", email);
    data.append("phone", phone);
    data.append("gdprConsent", gdprConsent);
    data.append("postersConsent", postersConsent);
    data.append("recaptcha", recaptchaCode);

    setFormState((f) => ({
      ...f,
      isSending: true,
    }));

    const response = await fetch(`${API_URL}/new-application/v2/?conf=${CONF}`, {
      method: "POST",
      body: data,
    });

    if (response.status === 201) {
      setFormState({
        ...initialFormState,
        isSending: false,
        sent: true,
      });
    } else {
      setFormState({
        ...formState,
        isSending: false,
        failure: true,
      });
    }
  };

  const handleTextInputChange = (event) => {
    event.persist();

    setFormState({
      ...formState,
      [event.target.name]: event.target.value,
    });
  };

  // const handleRecordingFileChange = (event) => {
  //   event.persist();
  //   if (
  //     ![
  //       "audio/mpeg",
  //       "video/mp4"
  //     ].includes(event.target.files[0].type)
  //   ) {
  //     setFormState({
  //       ...formState,
  //       recordingFileInvalid: true,
  //       recordingFileValidationMessage: "Obsługiwane typy plików to: mp3 i mp4.",
  //     });
  //     return;
  //   }

  //   if (event.target.files[0].size > 5e7) {
  //     setFormState({
  //       ...formState,
  //       recordingFileInvalid: true,
  //       recordingFileValidationMessage: "Maksymalny rozmiar pliku to 10MB.",
  //     });
  //     return;
  //   }

  //   setFormState({
  //     ...formState,
  //     recordingFileInvalid: false,
  //     recordingFile: event.target.files[0],
  //     recordingFileName: event.target.files[0].name,
  //   });
  // };

  const handleFileChange = (event) => {
    event.persist();
    if (
      ![
        "application/pdf",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "image/jpg",
        "image/jpeg"
      ].includes(event.target.files[0].type)
    ) {
      setFormState({
        ...formState,
        fileInvalid: true,
        validationMessage: "Obsługiwane typy plików to: jpeg, pptx, ppt i pdf.",
      });
      return;
    }

    if (event.target.files[0].size > 5e7) {
      setFormState({
        ...formState,
        fileInvalid: true,
        validationMessage: "Maksymalny rozmiar pliku to 10MB.",
      });
      return;
    }

    setFormState({
      ...formState,
      fileInvalid: false,
      file: event.target.files[0],
      fileName: event.target.files[0].name,
    });
  };

  useEffect(() => {
    const loadData = async () => {
      const posterDataResponse = await fetch(
        `${API_URL}/new-application/${formState.posterId}?conf=${CONF}`,
        {}
      );

      if (posterDataResponse.status === 200) {
        const posterData = await posterDataResponse.json();
        setFormState((f) => ({ ...f, ...posterData, posterIdInvalid: false }));
      } else if (posterDataResponse.status === 404) {
        setFormState((f) => ({
          ...initialFormState,
          posterId: f.posterId,
          posterIdInvalid: true,
          posterIdValidationMessage: "Plakat o podanym kodzie nie istnieje.",
        }));
      } else if (posterDataResponse.status === 409) {
        setFormState((f) => ({
          ...initialFormState,
          posterId: f.posterId,
          posterIdInvalid: true,
          posterIdValidationMessage:
            "Plakat o takim numerze już został umieszczony na Platformie. Chcesz zmienić plakat – skontaktuj się z Biurem Organizacyjnym – otrzymasz nowy kod.",
        }));
      } else {
        setFormState((f) => ({
          ...initialFormState,
          posterId: f.posterId,
          posterIdInvalid: true,
          posterIdValidationMessage: "Wprowadzono nieprawidłowy kod",
        }));
      }
    };

    if (formState.posterId.length === 3) {
      loadData();
    }
  }, [formState.posterId]);

  if (formState.sent) {
    return (
      <div className="new-application-container ">
        <div className="form-title">
          <h1>Zgłoszenie zostało przyjęte.</h1>
        </div>
      </div>
    );
  }

  return (
    <div className="new-application-container ">
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="posterId">
          <Form.Label>Kod plakatu*</Form.Label>
          <Form.Control
            isInvalid={formState.posterIdInvalid}
            name="posterId"
            onChange={handleTextInputChange}
            value={formState.posterId}
            type="text"
            placeholder="Kod plakatu"
          />
          <Form.Control.Feedback
            style={{
              display: formState.posterIdInvalid ? "block" : "none",
            }}
            type="invalid"
          >
            {formState.posterIdValidationMessage}
          </Form.Control.Feedback>
          <Form.Text className="text-muted">
            Podaj kod plakatu zgodnie z tabelą w ogłoszeniu o przyjętych
            plakatach:{" "}
            <a
              href="https://kongresdietetyka2026.pl/lista_plakatow/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://kongresdietetyka2026.pl/lista_plakatow/
            </a>
            . Wyszarzone pola wypełnią się automatycznie po podaniu pełnego kodu plakatu.
          </Form.Text>
        </Form.Group>
        <Form.Group controlId="title">
          <Form.Label>Tytuł*</Form.Label>
          <Form.Control
            as="textarea"
            rows={Math.floor(formState.title.length / 90) + 1}
            name="title"
            value={formState.title}
            disabled
            type="text"
            placeholder="np. Rozszerzone badania nad najnowszym odkryciem w dziedzinie medycyny"
          />
        </Form.Group>
        <Form.Group controlId="authors">
          <Form.Label>Autorzy*</Form.Label>
          <Form.Control
            name="authors"
            as="textarea"
            rows={Math.floor(formState.authors.length / 90) + 1}
            value={formState.authors}
            disabled
            type="text"
            placeholder="np. Grzegorz Autorowski, Paulina Autorska, Barbara Autorowicz"
          />
        </Form.Group>
        <Form.Group controlId="topic">
          <Form.Label>Temat*</Form.Label>
          <Form.Control
            name="topic"
            value={formState.topic}
            disabled
            type="text"
          />
        </Form.Group>
        <Form.Group controlId="session">
          <Form.Label>Sesja*</Form.Label>
          <Form.Control
            name="session"
            value={formState.session}
            disabled
            type="text"
          />
        </Form.Group>
        <Form.Group controlId="authorFacebook">
          <Form.Label>Afiliacja</Form.Label>
          <Form.Control
            name="authorFacebook"
            onChange={handleTextInputChange}
            value={formState.authorFacebook}
            type="text"
            placeholder="np. Wyższa Szkoła Zdrowia"
          />
        </Form.Group>
        <Form.Group controlId="presentationFile">
          <Form.Label>Plik prezentacji*</Form.Label>
          <Form.File
            isInvalid={formState.fileInvalid}
            required
            onChange={handleFileChange}
            id="custom-file"
            label={`${formState.fileName || "np. Prezentacja.pptx"}`}
            custom
          />
          <Form.Text className="text-muted">
            Obsługiwane typy plików to: jpeg, pptx, ppt i pdf.
          </Form.Text>
          <Form.Control.Feedback
            style={{
              display: formState.fileInvalid ? "block" : "none",
            }}
            type="invalid"
          >
            {formState.validationMessage}
          </Form.Control.Feedback>
        </Form.Group>
        <h4>
          Podaj dane kontaktowe autora, z którym mogą kontaktować się osoby
          zainteresowane przedstawioną pracą.
        </h4>
        <Form.Group controlId="authorFullName">
          <Form.Label>Tytuł, imię, nazwisko*</Form.Label>
          <Form.Control
            name="authorFullName"
            onChange={handleTextInputChange}
            value={formState.authorFullName}
            type="text"
            placeholder="np. dr n. med. Łukasz Koziński"
          />
        </Form.Group>
        <Form.Group controlId="authorEmail">
          <Form.Label>Adres email*</Form.Label>
          <Form.Control
            name="authorEmail"
            onChange={handleTextInputChange}
            value={formState.authorEmail}
            type="text"
            placeholder="np. michal.polonczyk@gmail.com"
          />
        </Form.Group>

        <h4>Podaj Twoje dane kontaktowe.</h4>
        <Form.Group controlId="fullName">
          <Form.Label>Imię, nazwisko*</Form.Label>
          <Form.Control
            name="fullName"
            onChange={handleTextInputChange}
            value={formState.fullName}
            type="text"
            placeholder="np. Łukasz Koziński"
          />
        </Form.Group>
        <Form.Group controlId="email">
          <Form.Label>Adres email*</Form.Label>
          <Form.Control
            name="email"
            onChange={handleTextInputChange}
            value={formState.email}
            type="text"
            placeholder="np. michal.polonczyk@gmail.com"
          />
        </Form.Group>
        <Form.Group controlId="phone">
          <Form.Label>Telefon*</Form.Label>
          <Form.Control
            name="phone"
            onChange={handleTextInputChange}
            value={formState.phone}
            type="text"
            placeholder="np. +48 599 999 999"
          />
        </Form.Group>

        <Form.Group controlId="gdprConsent">
          <Form.Text className="text-muted">
            Oświadczam, że zapoznałem/łam się z{" "}
            <a
              href="https://kongresdietetyka2026.pl/dokumenty/Dietetyka2026-RODO.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Klauzulą Informacyjną dot. Przetwarzania Danych Osobowych
            </a>{" "}
            oraz{" "}
            <a
              href="https://altasoft.pl/p_private_policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Polityką Prywatności AltaSoft
            </a>{" "}
            regulującymi kwestie przetwarzania moich danych osobowych przez
            AltaSoft sp. z o.o.*
          </Form.Text>
          <Form.Check
            value={formState.gdprConsent}
            onChange={(event) => {
              setFormState({
                ...formState,
                gdprConsent: event.target.checked,
              });
            }}
            type="checkbox"
            label="Wyrażam zgodę"
            feedback="Wyrażenie tej zgody jest warunkiem koniecznym uczestnictwa w konkursie"
          />
        </Form.Group>
        <Form.Group controlId="postersConsent">
          <Form.Text className="text-muted">
            Wyrażam zgodę na przetwarzanie moich danych osobowych zawartych w
            przesłanej aplikacji dla potrzeb niezbędnych do prezentacji plakatu
            w trakcie Międzynarodowego Kongresu Dietetyka 2026 przez AltaSoft sp. z o.o.*
          </Form.Text>
          <Form.Check
            value={formState.postersConsent}
            onChange={(event) => {
              setFormState({
                ...formState,
                postersConsent: event.target.checked,
              });
            }}
            type="checkbox"
            feedback="Wyrażenie tej zgody jest warunkiem koniecznym uczestnictwa w konkursie"
            label="Wyrażam zgodę"
          />
          <Form.Text className="text-muted">
            Administratorem Państwa danych osobowych jest AltaSoft sp. z o.o. (dalej AltaSoft) z siedzibą ul.
            Pukowca 15, 40-847 Katowice, tel. +48 322598399/98/96, KRS: 0000558517, REGON: 361525651, NIP: 634-28-39-789 Podanie danych jest
            dobrowolne, aczkolwiek jest niezbędne do zamieszczenia plakatu w Strefie Uczestnika Kongresu i dalej do jego prezentacji w trakcie Kongresu. Przysługuje Państwu prawo dostępu do
            swoich danych osobowych, ich poprawy oraz żądania usunięcia (w tym
            do bycia zapomnianym) przez kontakt z Biurem Obsługi Konferencji
            AltaSoft (adres jak wyżej) lub mailowo na adres
            konferencje@altasoft.pl. Każda osoba, której dane dotyczą ma prawo
            wnieść także skargę do organu nadzorczego, jeżeli sądzi, że
            przetwarzanie danych osobowych jej dotyczące narusza obowiązujące
            przepisy. Państwa dane przetwarzane są do momentu cofnięcia zgody na
            ich przetwarzanie lub do momentu realizacji lub zaprzestania przez
            AltaSoft realizacji celu ich przetwarzania. AltaSoft podejmuje
            wszelkie stosowne środki bezpieczeństwa zgodne z aktualnie
            obowiązującymi przepisami prawa, a także powszechnie przyjętymi
            zasadami służącymi ochronie poufności informacji, w szczególności z
            Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia
            27 kwietnia 2016 r.
          </Form.Text>
          <Form.Text className="text-muted">
            * pola oznaczone gwiazdką są wymagane.
          </Form.Text>
        </Form.Group>
        <div className="form-submit">
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey="6Ld6QMMaAAAAAIAY9tDFWw7B_m_LNlSFENwp7gnz"
          />
          <Button
            disabled={formState.posterIdInvalid || formState.isSending}
            variant="primary"
            type="submit"
          >
            {formState.isSending ? "Wysyłanie..." : "Wyślij"}
          </Button>
          <Form.Control.Feedback
            style={{
              display: formState.failure ? "block" : "none",
            }}
            type="invalid"
          >
            Błąd wysyłania formularza. Upewnij się, że wprowadzone dane są
            prawidłowe i spróbuj jeszcze raz. Gdy błąd będzie się powtarzał,
            skontaktuj sie z Biurem Organizacyjnym.
          </Form.Control.Feedback>
        </div>
      </Form>
    </div>
  );
};

export default NewApplication;
